<template>
  <v-container id="regular-forms" fluid tag="section">
    <v-row>
      <v-col cols="12">
        <base-material-card
          color="grey darken-3"
          icon="mdi-account"
          :title="$t('Show Emaillogs')"
          class="px-5 py-3"
        >
          <v-progress-linear
            indeterminate
            rounded
            height="6"
            v-if="loading"
          ></v-progress-linear>
          <v-form
            v-else
            ref="form"
            autocomplete="new-password"
            lazy-validation
            @submit.prevent="saveItem"
          >
            <v-text-field
              v-model="formValues.to"
              :label="$t('email_to')"
              disabled
            ></v-text-field>
            <v-text-field
            v-if="formValues.cc"
            v-model="formValues.cc"
            :label="$t('email_cc')"
            disabled
          ></v-text-field>
          <v-text-field
            v-if="formValues.bcc"
            v-model="formValues.bcc"
            :label="$t('email_bcc')"
            disabled
          ></v-text-field>
          <v-text-field
            v-model="formValues.created_at"
            :label="$t('email_sent_at')"
            disabled
          ></v-text-field>
          <v-text-field
            v-model="formValues.subject"
            :label="$t('email_subject')"
            disabled
          ></v-text-field>

          <p class="mt-3">{{ $t('email_content') }}:</p>
          <div>
            <span v-html="formValues.body"></span>

          </div>

            <v-card-actions class="pl-0">
              <v-btn
                color="primary"
                class="mr-4"
                @click="$router.push({ name: 'emailLogs.index' })"
              >
                {{ $t("back") }}
              </v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-form>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { saveItem, fetchItem } from "../shared/services";
export default {
  name: "app-emailLogs-item",
  $_veeValidate: {
    validator: "new"
  },
  data() {
    return {
      formValues: {
        to: ""
      },
      permissions: [],
      loading: true,
      headers: [
        {
          text: "Name",
          align: "left",
          value: "name"
        },
        { text: "Email", value: "email" },
        { text: "", value: "action", sortable: false }
      ]
    };
  },
  mounted() {
    if (this.$route.params.id) {
      this.loading = true;
      fetchItem(this.$route.params.id).then(res => {
        this.formValues = res.data;
        this.loading = false;
      });
    } else {
      this.loading = false;
    }
  },
  computed: {
    computedFormValues() {
      return {
        ...this.formValues
      };
    }
  },
};
</script>

<style lang="scss" scoped></style>
